import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ChangelogService } from '@app/core/api/changelog.service';
import { ClFeature } from '@app/shared/changelog/version/version-detail/clfeature.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgFor } from '@angular/common';
import { VersionDetailComponent } from './version-detail/version-detail.component';

@UntilDestroy()
@Component({
  selector:        'app-version',
  templateUrl:     './cl-version.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [
    NgFor,
    VersionDetailComponent
  ]
})
export class ClVersionComponent implements OnInit {
  features: ClFeature[];

  constructor(private changelogService: ChangelogService, private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.changelogService.clickedVersion.pipe(untilDestroyed(this)).subscribe((version: number) => {
      this.features = this.changelogService.getFeatures(version);
      this.cd.markForCheck();
    });
  }
}
